import { powerManagementInit } from "../models/tq8-power-management.models";
import type { PowerManagementItem } from "../models/tq8-power-management.models";

export function preparePowerRowsForEditing(value: unknown): PowerManagementItem[] {
  const rows = Array.isArray(value) ? value : [];
  return powerManagementInit.map((defaultRow) => {
    const row =
      rows.find((item) => item?.name === defaultRow.name) || rows.find((item) => Number(item?.id) === defaultRow.id);
    return { ...defaultRow, ...row, id: defaultRow.id, name: defaultRow.name };
  });
}
